import { render, staticRenderFns } from "./OnOffMachine.vue?vue&type=template&id=8d53caca&"
import script from "./OnOffMachine.vue?vue&type=script&lang=js&"
export * from "./OnOffMachine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports